<template >
    <div>

        <b-form inline>
            <b-form-checkbox-group
                v-model="filter.status"
                :options="$store.state.statusList"
                class="mb-2"
            ></b-form-checkbox-group>

            <b-form-select
                placeholder="Кому"
                v-model="filter.user"
                :options="usersForList"
                required
                class="mb-2"
                style="width:25%;"
            ></b-form-select>
            <b-button @click="clearFilter" class="mb-2" variant="danger">Сбросить фильтр</b-button>
        </b-form>

        <b-table
            :items="items"
            :fields="fields"
            :filter="filter"
            :filter-function="filterFunction"
        >

        <template #cell(actions)="row">
            <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? 'Скрыть' : 'Изменить Удалить' }}
            </b-button>
      </template>

        <template #row-details="row">
            <addOperations
                :operationDefault="row.item"
                @update-operations-table="updateOperationsTable()"
                mode="edit"
            />
            <!-- {{row}} -->
        </template>
        </b-table>

    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import addOperations from './addOperations.vue'
export default {
    props: ['items'],
    components: {
        addOperations
    },
    data() {
        return {
            filter: {
                status: [ 'planned', 'accrued' ],
                user: null,
            },
            // {value: 'draft', text: 'Черновик'},
            // {value: 'planned', text: 'Запланировано'},
            // {value: 'accrued', text: 'Начислено'},
            // {value: 'paid', text: 'Выплачено'},
            // {value: 'issued', text: 'Оформлено'}

            fields:
            [
                {
                    key: 'status',
                    label: 'Статус',
                    sortable: true,
                    sortDesc: false,
                    formatter: value => {
                        let status = this.$store.state.statusList.find ( item => item.value == value )
                        return status ? status.text : null
                    }
                },
                {
                    key: 'user',
                    label: 'Исполнитель',
                    sortable: true,
                    sortDesc: false,
                    formatter: value => {
                        let user = this.$store.state.users.find ( item => item.ID == value )
                        let fullName = user ? user.LAST_NAME + ' ' + user.NAME : 'Безродных'
                       return fullName
                    }
                },
                {
                    key: 'reference',
                    label: 'Наименование операции'
                },
                {
                    key: 'amount',
                    label: 'Сумма',
                },
                {
                    key: 'typeOfPayment',
                    label: 'Форма рассчета',
                    sortable: true,
                    sortDesc: false,
                    formatter: value => {
                        let typeOfPayment = this.$store.state.typeOfPaymentList.find ( item => item.value == value )
                        return typeOfPayment ? typeOfPayment.text : ''
                    }
                },
                {
                    key: 'dataSort',
                    label: 'Дата',
                    sortable: true,
                    sortDesc: false,
                    formatter: value => {
                        let date = value ? (new Date (value) ).toLocaleDateString("ru") : 'нет даты'
                        return date
                    }
                },
                {
                    key: 'actions',
                    label: 'Действия'
                },
                {
                    key: 'task',
                    label: 'Задача',
                    sortable: true,
                    sortDesc: false
                },
                {
                    key: 'deal',
                    label: 'Сделка',
                    sortable: true,
                    sortDesc: false
                },
                {
                    key: 'company',
                    label: 'Компания',
                    sortable: true,
                    sortDesc: false
                },
                {
                    key: 'contact',
                    label: 'Контакт',
                    sortable: true,
                    sortDesc: false
                },
            ]
        }
    },
    computed: {
        // ...mapState(['statusList', 'typeOfPaymentList']),
        ...mapGetters(['getStatusName', 'getTypeOfPaymentName', 'getContactName' ]),
        usersForList() {
            let users = this.$store.getters.getUsersForList
            users.unshift ( { value: null, text: 'все пользователи' } )
            return users
        }
    },
    methods: {
        clearFilter(){
                this.filter.user = null
                this.filter.status = [ 'draft', 'planned', 'accrued', 'accrued', 'paid', 'issued' ]
        },
        updateOperationsTable(){
            this.$emit('update-operations-table')
        },
        filterFunction(row, val){
            // row -  item row record data object. Treat this argument as read-only.
            // val - the content of the filter prop (could be a string, RegExp, array, or object)
            const { status: status, user: user } = val

            let result = user ? status.includes ( row.status ) && row.user == user : status.includes ( row.status )

            return result
        }
    },
}
</script>
<style lang="">

</style>